<template>
    <form @submit.prevent="store" class="settings-block">
        <div class="block-header">
            <h3>{{ $t('Интеграция с банками') }}</h3>
        </div>
        <div class="block-content">
            <div class="btn-group btn-nav-group">
                <button type="button" 
                    @click="selected = bank" 
                    v-for="bank in banks" :key="bank.key" 
                    :class="{'btn': true, 'btn-blue': selected.key == bank.key, 'btn-light': selected.key != bank.key}">
                    <i :class="`icon icon-${bank.key} m mr-5`"></i> 
                    {{ $t(bank.title) }}
                </button>
            </div>
            
            <Monobank v-if="selected.key == 'monobank'" />
            <PrivatBank v-if="selected.key == 'privatbank'" />
        </div>
    </form>
</template>

<script>
import { EventBus } from '../../../event-bus';

import Monobank from "./Integrations/Monobank.vue";
import PrivatBank from "./Integrations/PrivatBank.vue";

export default {
    name: "Integration",

    components: {
        Monobank,
        PrivatBank
    },

    data: function() {
        return {
            selected: {key: "monobank", title: "Монобанк"},

            banks: [
                {key: "monobank", title: "Монобанк"},
                {key: "privatbank", title: "ПриватБанк"},
            ],
        };
    },
};
</script>